import { ToastType } from './../../../../enums/toast-type.enum';
import { AfterViewInit, ChangeDetectorRef, ElementRef, Inject, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { ToastMessage } from '../../../../models/toast-message';
import { LocalService } from '../../../../services';
declare var bootstrap: any;

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements AfterViewInit {
  @ViewChild("sampleToast", { static: false }) sampleToast?: ElementRef;
  title: string = "";
  body: string = "";
  textClass: string = "";
  backgroundClass: string = "";

  constructor(private localService: LocalService,
    private cdRef: ChangeDetectorRef,
    @Inject("IMAGES_URL") public imagesUrl: string) { }

  showToast(body: string, title: string, toastType: ToastType) {
    if (this.sampleToast) {
      this.title = title;
      this.body = body;
      this.backgroundClass = this.getBackgroundClass(toastType);
      this.textClass = this.getTextClass(toastType);

      this.cdRef.detectChanges();

      var myToast = bootstrap.Toast.getOrCreateInstance(this.sampleToast.nativeElement);
      myToast.show();
    }
  }

  ngAfterViewInit() {
    this.localService.toasts.subscribe((res: ToastMessage) => {
      if (res.body)
        this.showToast(res.body, res.title, res.toastType);
    })
  }

  getBackgroundClass(toastType: ToastType): string {
    switch (toastType) {
      case ToastType.Default:
        return "";
      case ToastType.Error:
        return "bg-danger";
      default: return "";
    }
  }

  getTextClass(toastType: ToastType): string {
    switch (toastType) {
      case ToastType.Default:
        return "";
      case ToastType.Error:
        return "text-light";
      default: return "";
    }
  }
}
